import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/salehe.svg'
import _imports_1 from '@/assets/saweetie.svg'
import _imports_2 from '@/assets/sza.svg'


const _withScopeId = n => (_pushScopeId("data-v-a9cc4a72"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"salehe\" data-v-a9cc4a72><div class=\"cmp\" data-v-a9cc4a72><div class=\"sect_1\" data-v-a9cc4a72><h1 data-animation=\"paragraph\" data-v-a9cc4a72>Salehe Bembury Crocs</h1><p data-animation=\"paragraph\" data-v-a9cc4a72>Jump into the artistic world of Salehe where he brings his unique designs to crocs.</p><div class=\"btn\" data-v-a9cc4a72><a href=\"https://www.crocs.com/c/footwear\" data-v-a9cc4a72><button data-v-a9cc4a72>Shop Crocs</button></a></div></div></div><div class=\"cmp\" data-v-a9cc4a72><div class=\"sect_2\" data-v-a9cc4a72><div class=\"img\" data-v-a9cc4a72><img src=\"" + _imports_0 + "\" alt=\"\" data-v-a9cc4a72></div><canvas data-animation=\"matter-drop\" data-v-a9cc4a72></canvas></div></div></section><section class=\"saweetie\" data-v-a9cc4a72><div class=\"cmp\" data-v-a9cc4a72><div class=\"sect_1\" data-v-a9cc4a72><h1 data-animation=\"header\" data-v-a9cc4a72>Saweetie Sweet Crocs</h1><p data-animation=\"paragraph\" data-v-a9cc4a72> Make hearts melt but keep your Jibbitz looking cold with an icy drip that only Saweetie can provide. Our all-new Saweetie X Crocs Jibbitz charms are ready to be paired with the irresistible Classic Clogs </p><div class=\"btn\" data-v-a9cc4a72><a href=\"https://www.crocs.com/c/footwear\" data-v-a9cc4a72><button data-v-a9cc4a72>Shop Crocs</button></a></div></div></div><div class=\"cmp\" data-v-a9cc4a72><div class=\"sect_2\" data-v-a9cc4a72><div class=\"img\" data-v-a9cc4a72><img src=\"" + _imports_1 + "\" alt=\"\" data-v-a9cc4a72></div><canvas data-animation=\"matter-drop\" data-v-a9cc4a72></canvas></div></div></section><section class=\"sza\" data-v-a9cc4a72><div class=\"cmp\" data-v-a9cc4a72><div class=\"sect_1\" data-v-a9cc4a72><h1 data-animation=\"header\" data-v-a9cc4a72>Sza Unique Crocs</h1><p data-animation=\"paragraph\" data-v-a9cc4a72> The SZA X Crocs Classic Clog puts her personality up top, with colorful Jibbitz charms that showcase the world of SZA, totems that keep her grounded, calm, and collective. </p><div class=\"btn\" data-v-a9cc4a72><a href=\"https://www.crocs.com/c/footwear\" data-v-a9cc4a72><button data-v-a9cc4a72>Shop Crocs</button></a></div></div></div><div class=\"cmp\" data-v-a9cc4a72><div class=\"sect_2\" data-v-a9cc4a72><div class=\"img\" data-v-a9cc4a72><img src=\"" + _imports_2 + "\" alt=\"\" data-v-a9cc4a72></div><canvas data-animation=\"matter-drop\" data-v-a9cc4a72></canvas></div></div></section>", 3)

import { onMounted } from "@vue/runtime-core";
import { fallSync } from "../animations/matter/fall";


export default /*#__PURE__*/_defineComponent({
  __name: 'featured',
  setup(__props) {

onMounted(() => {
     const sza = document.querySelector<HTMLElement>(".sza")!;
     const salehe = document.querySelector<HTMLElement>(".salehe")!;
     const saweetie = document.querySelector<HTMLElement>(".saweetie")!;
     fallSync(sza, [
          "/stickers/s15.svg",
          "/stickers/space.png",
          "/stickers/s16.svg",
          "/stickers/space.png",
          "/stickers/s17.svg",
          "/stickers/space.png",
          "/stickers/s18.svg",
     ]);

     fallSync(saweetie, [
          "/stickers/s8.svg",
          "/stickers/s9.svg",
          "/stickers/s10.svg",
          "/stickers/s11.svg",
          "/stickers/s12.svg",
          "/stickers/s13.svg",
          "/stickers/s14.svg",
     ]);

     fallSync(salehe, [
          "/stickers/s1.svg",
          "/stickers/s2.svg",
          "/stickers/s3.svg",
          "/stickers/s4.svg",
          "/stickers/s5.svg",
          "/stickers/s6.svg",
          "/stickers/s7.svg",
     ]);
});

return (_ctx: any,_cache: any) => {
  return _hoisted_1
}
}

})